import { render, staticRenderFns } from "./MenuSquare.vue?vue&type=template&id=7761f823&scoped=true&"
import script from "./MenuSquare.vue?vue&type=script&lang=js&"
export * from "./MenuSquare.vue?vue&type=script&lang=js&"
import style0 from "./MenuSquare.vue?vue&type=style&index=0&id=7761f823&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7761f823",
  null
  
)

export default component.exports